import { render, staticRenderFns } from "./MovingImagesImageInputAnswer.vue?vue&type=template&id=34f2229a&scoped=true&"
import script from "./MovingImagesImageInputAnswer.vue?vue&type=script&lang=ts&"
export * from "./MovingImagesImageInputAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./MovingImagesImageInputAnswer.vue?vue&type=style&index=0&id=34f2229a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2229a",
  null
  
)

export default component.exports